export default __webpack_public_path__ + "static/media/rice.cc40226a.png";